'use strict'

const SELECTORS = {
    element: '.js-footer',
    seoWrp: '.js-footer-seo-wrp',
    seoToggle: '.js-footer-seo-toggle',
    seoContent: '.js-footer-seo-content'
};

$(() => {
    $(document).on('click', SELECTORS.seoToggle, function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).closest(SELECTORS.seoWrp).hasClass('cc-expanded')) {
            $(this).closest(SELECTORS.seoWrp).removeClass('cc-expanded');
            $(this).attr('aria-expanded', 'false');
        } else {
            $(this).closest(SELECTORS.seoWrp).addClass('cc-expanded');
            $(this).attr('aria-expanded', 'true');
        }
    });

    $('.js-footer-accordion-m').each(function () {
        const $btn = $(this);

        if (window.isDesktop) {
            $btn.prop('disabled', true);
            $btn.attr('tabindex', -1);
            $btn.removeAttr('aria-expanded aria-controls');
        }
    });
});
